<template>
  <div class="container">
    <div class="bindWrap">
      <p class="pb22 fs16 fwb">{{ $t("account.email.email") }}</p>
      <el-form :model="emailForm" :rules="emailRules" ref="emailForm" label-width="0px" class="msContent">
        <el-form-item prop="email">
          <el-input
            type="text"
            v-model="emailForm.email"
            :placeholder="$t('account.email.newEmail')"
            @keyup.enter.native="submitForm('emailForm')"
            v-regexFilter="$halfWidthRegex"
            class="fl mr16 wd360"
          ></el-input>
          <p class="fl green" v-if="sendState">
            <span class="el-icon-document-checked"></span>
            {{ $t("account.email.verify") }}
          </p>
        </el-form-item>
        <div class="wdb100 login-btn">
          <el-button type="primary" @click="submitForm('emailForm')">{{ $t("account.email.send") }}</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { postRequest } from "@/api/common";
import { mapGetters } from "vuex";
export default {
  name: "ChangeEmail",
  data() {
    return {
      clickSwitch: true, // 防止恶意提交
      sendState: false,
      emailForm: {
        email: null,
      },
      emailRules: {
        email: [
          {
            required: true,
            message: this.$t("common.placeholder.enter"),
            trigger: "submit",
          },
          {
            type: "email",
            message: this.$t("common.regular.email"),
            trigger: "submit",
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters("language", ["getLanguage"]),
  },
  methods: {
    // 修改 - 按钮
    submitForm(emailForm) {
      this.$refs[emailForm].validate(valid => {
        if (valid) {
          if (this.clickSwitch) {
            this.clickSwitch = false;
            postRequest("/changeEmail", {
              email: this.emailForm.email,
            })
              .then(res => {
                this.sendState = true;
                this.$message.info(this.$t("common.info.emailSend"));
              })
              .catch(err => {
                this.clickSwitch = true;
              });
          }
        } else {
          return false;
        }
      });
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped></style>
